module.exports = {
    pageSettings: {
        startScreen: {
            backgroundImage: `url(${require('@/assets/Ebene-1/LR-hauptseite_hintergrund.jpg')})`,
            backDestinationName: 'root',
            backDestinationParam: '',

            tiles: [
                //ZEILE 1
                {
                    action: 'menu',
                    actionParam: 'immunsystem',
                    style: {
                        left: "6%",
                        top: "20%",
                        backgroundImage: `url(${require("@/assets/Ebene-1/LR-hauptseite_kachel_IMMUNSYSTEM.png")})`
                    }
                },
                {
                    action: 'menu',
                    actionParam: 'beweglichkeit',
                    style: {
                        left: "24%",
                        top: "20%",
                        backgroundImage: `url(${require("@/assets/Ebene-1/LR-hauptseite_kachel_BEWEGLICHKEIT.png")})`
                    }
                },
                {
                    action: 'menu',
                    actionParam: 'kreislauf',
                    style: {
                        left: "42%",
                        top: "20%",
                        backgroundImage: `url(${require("@/assets/Ebene-1/LR-hauptseite_kachel_HERZKREISLAUF.png")})`
                    }
                },
                {
                    action: 'menu',
                    actionParam: 'erschoepfung',
                    style: {
                        left: "60%",
                        top: "20%",
                        backgroundImage: `url(${require("@/assets/Ebene-1/LR-hauptseite_kachel_ERSCHOEPFUNG.png")})`
                    }
                },
                {
                    action: 'menu',
                    actionParam: 'stress',
                    style: {
                        left: "78%",
                        top: "20%",
                        backgroundImage: `url(${require("@/assets/Ebene-1/LR-hauptseite_kachel_STRESS.png")})`
                    }
                },


                //ZEILE 2
                {
                    action: 'menu',
                    actionParam: 'allergien',
                    style: {
                        left: "6%",
                        top: "39%",
                        backgroundImage: `url(${require("@/assets/Ebene-1/LR-hauptseite_kachel_ALLERGIEN.png")})`
                    }
                },
                {
                    action: 'menu',
                    actionParam: 'zahnmund',
                    style: {
                        left: "24%",
                        top: "39%",
                        backgroundImage: `url(${require("@/assets/Ebene-1/LR-hauptseite_kachel_ZAHN.png")})`
                    }
                },
                {
                    action: 'menu',
                    actionParam: 'verletzungen',
                    style: {
                        left: "42%",
                        top: "39%",
                        backgroundImage: `url(${require("@/assets/Ebene-1/LR-hauptseite_kachel_VERLETZUNGEN.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'tiergesundheit',
                    style: {
                        left: "60%",
                        top: "39%",
                        backgroundImage: `url(${require("@/assets/Ebene-1/LR-hauptseite_kachel-tiergesundheit.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'monatsangebote',
                    style: {
                        left: "78%",
                        top: "39%",
                        backgroundImage: `url(${require("@/assets/Ebene-1/LR-hauptseite_kachel_aktuelle_Monatsangebote.png")})`
                    }
                },


                //ZEILE 3
                {
                    action: 'menu',
                    actionParam: 'fuerjedelebenslage',
                    style: {
                        left: "6%",
                        top: "58%",
                        backgroundImage: `url(${require("@/assets/Ebene-1/LR-hauptseite_kachel_LOESUNGENFUERJEDELEBENSLAGE.png")})`
                    }
                },
                {
                    action: 'menu',
                    actionParam: 'einzelneprodukte',
                    style: {
                        left: "24%",
                        top: "58%",
                        backgroundImage: `url(${require("@/assets/Ebene-1/LR-hauptseite_kachel_EINZELNEPRODUKTE.png")})`
                    }
                },
                {
                    action: 'menu',
                    actionParam: 'kopfbisfuss',
                    style: {
                        left: "42%",
                        top: "58%",
                        backgroundImage: `url(${require("@/assets/Ebene-1/LR-hauptseite_kachel_ALOEVIA.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'bodymission',
                    style: {
                        left: "60%",
                        top: "58%",
                        backgroundImage: `url(${require("@/assets/Ebene-1/LR-hauptseite_kachel_BODYMISSION.png")})`
                    }
                },
                {
                    action: 'menu',
                    actionParam: 'duefte',
                    style: {
                        left: "78%",
                        top: "58%",
                        backgroundImage: `url(${require("@/assets/Ebene-1/LR-hauptseite_kachel_DUEFTE.png")})`
                    }
                },


                //ZEILE 4
                {
                    action: 'video',
                    actionParam: 'truebeauty',
                    style: {
                        left: "6%",
                        top: "77%",
                        backgroundImage: `url(${require("@/assets/Ebene-1/LR-hauptseite_kachel_TRUEBEAUTY.png")})`
                    }
                },
                {
                    action: 'video',
                    actionParam: 'zeitgard',
                    style: {
                        left: "24%",
                        top: "77%",
                        backgroundImage: `url(${require("@/assets/Ebene-1/LR-hauptseite_kachel_ZEITGARD.png")})`
                    }
                },
                // {
                //     action: 'video',
                //     actionParam: 'nightmaster',
                //     style: {
                //         left: "42%",
                //         top: "77%",
                //         backgroundImage: `url(${require("@/assets/Ebene-1/LR-hauptseite_kachel_NIGHTMASTER.png")})`
                //     }
                // },
                // {
                //     action: 'video',
                //     actionParam: 'cannaloe',
                //     style: {
                //         left: "42%",
                //         top: "77%",
                //         backgroundImage: `url(${require("@/assets/Ebene-1/LR-hauptseite_kachel-cannaloe.png")})`
                //     }
                // },
                {
                    action: 'video',
                    actionParam: 'mens_shot',
                    style: {
                        left: "42%",
                        top: "77%",
                        backgroundImage: `url(${require("@/assets/Ebene-1/LR-hauptseite_kachel-mens-shot.png")})`
                    }
                },
                {
                    action: 'video',
                    actionParam: 'cell_essence',
                    style: {
                        left: "60%",
                        top: "77%",
                        backgroundImage: `url(${require("@/assets/Ebene-1/LR-hauptseite_kachel-cell-essence.png")})`
                    }
                },
                {
                    action: 'video',
                    actionParam: 'aromatherapie',
                    style: {
                        left: "78%",
                        top: "77%",
                        backgroundImage: `url(${require("@/assets/Ebene-1/LR-hauptseite_Aromatherapie.png")})`
                    }
                },
            ]
        },

        immunsystem: {
            backgroundImage: `url(${require('@/assets/Ebene-2/zeile-1_1_Ein_kraftvolles_Immunssystem/LR-anwendungsgebiete_IMMUNSYSTEM_startseite-hintergrund.jpg')})`,
            backDestinationName: 'root',
            backDestinationParam: '',
            tiles: [
                //ZEILE 1
                {
                    action: 'slides',
                    actionParam: 'immunsystem_aloevera_trinkgel_honey',
                    style: {
                        left: "6%",
                        top: "20%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-1_1_Ein_kraftvolles_Immunssystem/Kachel/LR-anwendungsgebiete_IMMUNSYSTEM_kacheln_honey.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'immunsystem_cistus_kapseln',
                    style: {
                        left: "24%",
                        top: "20%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-1_1_Ein_kraftvolles_Immunssystem/Kachel/LR-anwendungsgebiete_IMMUNSYSTEM_kacheln_cistuskapseln.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'immunsystem_cistus_incanus_tee',
                    style: {
                        left: "42%",
                        top: "20%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-1_1_Ein_kraftvolles_Immunssystem/Kachel/LR-anwendungsgebiete_IMMUNSYSTEM_kachel-tee.png")})`
                    }
                },




                //ZEILE 2
                {
                    action: 'product',
                    actionParam: 'immunsystem_cistus_mundspray',
                    style: {
                        left: "6%",
                        top: "39%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-1_1_Ein_kraftvolles_Immunssystem/Kachel/LR-anwendungsgebiete_IMMUNSYSTEM_kacheln-cistusmundspray.png")})`
                    }
                },
                {
                    action: 'product',
                    actionParam: 'immunsystem_colostrum_kapseln',
                    style: {
                        left: "24%",
                        top: "39%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-1_1_Ein_kraftvolles_Immunssystem/Kachel/LR-anwendungsgebiete_IMMUNSYSTEM_kacheln_colustrumkapseln.png")})`
                    }
                },
                {
                    action: 'product',
                    actionParam: 'immunsystem_colostrum_liquid',
                    style: {
                        left: "42%",
                        top: "39%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-1_1_Ein_kraftvolles_Immunssystem/Kachel/LR-anwendungsgebiete_IMMUNSYSTEM_kacheln-colostrumliquid.png")})`
                    }
                },

                //ZEILE 3
                {
                    action: 'product',
                    actionParam: 'immunsystem_vita_aktiv_rote_fruechte',
                    style: {
                        left: "6%",
                        top: "58%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-1_1_Ein_kraftvolles_Immunssystem/Kachel/LR-anwendungsgebiete_IMMUNSYSTEM_kacheln-rotefruechte.png")})`
                    }
                },
                {
                    action: 'product',
                    actionParam: 'immunsystem_pro12',
                    style: {
                        left: "24%",
                        top: "58%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-1_1_Ein_kraftvolles_Immunssystem/Kachel/LR-anwendungsgebiete_IMMUNSYSTEM_kacheln-pro12.png")})`
                    }
                },
            ]
        },

        beweglichkeit: {
            backgroundImage: `url(${require('@/assets/Ebene-2/zeile-1_2_Beweglichkeit/LR-anwendungsgebiete_BEWEGLICHKEIT_seite01-hintergrund.jpg')})`,
            backDestinationName: 'root',
            backDestinationParam: '',
            tiles: [
                //ZEILE 1
                {
                    action: 'product',
                    actionParam: 'beweglichkeit_aloevera_trinkgel_freedom',
                    style: {
                        left: "6%",
                        top: "20%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-1_2_Beweglichkeit/Kacheln/kachel_ALOEVERATRINKGELFREEDOM.png")})`
                    }
                },
                {
                    action: 'product',
                    actionParam: 'beweglichkeit_freedom_kapseln',
                    style: {
                        left: "24%",
                        top: "20%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-1_2_Beweglichkeit/Kacheln/kachel_BEWEGLICHKEIT_freeedomkapseln.png")})`
                    }
                },
                {
                    action: 'product',
                    actionParam: 'beweglichkeit_pro_balance',
                    style: {
                        left: "42%",
                        top: "20%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-1_2_Beweglichkeit/Kacheln/kachel_BEWEGLICHKEIT_probalance.png")})`
                    }
                },


                //ZEILE 2
                {
                    action: 'product',
                    actionParam: 'beweglichkeit_colostrum_kapseln',
                    style: {
                        left: "6%",
                        top: "39%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-1_2_Beweglichkeit/Kacheln/kachel_COLOSTRUMKAPSELN.png")})`
                    }
                },
                {
                    action: 'product',
                    actionParam: 'beweglichkeit_colostrum_liquid',
                    style: {
                        left: "24%",
                        top: "39%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-1_2_Beweglichkeit/Kacheln/kachel_BEWEGLICHKEIT_colustrumliquid.png")})`
                    }
                },
                {
                    action: 'product',
                    actionParam: 'beweglichkeit_msm_bodygel',
                    style: {
                        left: "42%",
                        top: "39%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-1_2_Beweglichkeit/Kacheln/kachel_BEWEGLICHKEIT_bodygel.png")})`
                    }
                },


                //ZEILE 3
                {
                    action: 'product',
                    actionParam: 'beweglichkeit_thermo_lotion',
                    style: {
                        left: "6%",
                        top: "58%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-1_2_Beweglichkeit/Kacheln/kachel_BEWEGLICHKEIT_thermolotion.png")})`
                    }
                },
            ]
        },


        kreislauf: {
            backgroundImage: `url(${require('@/assets/Ebene-2/zeile-1_3_Herz_und_Kreislauf/LR-anwendungsgebiete_STAERKUNGHERZKREISLAUF_hauptseite-hintergrund.jpg')})`,
            backDestinationName: 'root',
            backDestinationParam: '',
            tiles: [
                //ZEILE 1
                {
                    action: 'product',
                    actionParam: 'kreislauf_aloevera_trinkgel_sivera',
                    style: {
                        left: "6%",
                        top: "20%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-1_3_Herz_und_Kreislauf/Kacheln/kachel-HERZKREISLAUF-ALOEVERATRINKGELSIVERA.png")})`
                    }
                },
                {
                    action: 'product',
                    actionParam: 'kreislauf_omega3',
                    style: {
                        left: "24%",
                        top: "20%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-1_3_Herz_und_Kreislauf/Kacheln/kachel-HERZKREISLAUF-OMEGA3.png")})`
                    }
                },
                {
                    action: 'product',
                    actionParam: 'kreislauf_pro_balance',
                    style: {
                        left: "42%",
                        top: "20%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-1_3_Herz_und_Kreislauf/Kacheln/kachel-HERZKREISLAUF-PROBALANCE.png")})`
                    }
                },


                //ZEILE 2
                {
                    action: 'product',
                    actionParam: 'kreislauf_vita_aktiv',
                    style: {
                        left: "6%",
                        top: "39%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-1_3_Herz_und_Kreislauf/Kacheln/kachel-HERZKREISLAUF-VITAAKTIV.png")})`
                    }
                },
                {
                    action: 'product',
                    actionParam: 'kreislauf_cistus_tee',
                    style: {
                        left: "24%",
                        top: "39%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-1_3_Herz_und_Kreislauf/Kacheln/kachel-HERZKREISLAUF-CISTUSTEE.png")})`
                    }
                },
                {
                    action: 'product',
                    actionParam: 'kreislauf_reishi',
                    style: {
                        left: "42%",
                        top: "39%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-1_3_Herz_und_Kreislauf/Kacheln/kachel-HERZKREISLAUF-REISHI.png")})`
                    }
                },

            ]
        },

        erschoepfung: {
            backgroundImage: `url(${require('@/assets/Ebene-2/zeile-1_4_Erschoepfung/LR-anwendungsgebiete_ERSCHOEPFUNG_hauptseite-hintergrund.jpg')})`,
            backDestinationName: 'root',
            backDestinationParam: '',
            tiles: [
                //ZEILE 1
                {
                    action: 'slides',
                    actionParam: 'erschoepfung_aloevera_trinkgel_alle_sorten',
                    style: {
                        left: "6%",
                        top: "20%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-1_4_Erschoepfung/Kacheln/kachel-ERSCHOEPFUNG_ALOEVERATRINKGELE.png")})`
                    }
                },
                {
                    action: 'product',
                    actionParam: 'erschoepfung_vita_aktiv',
                    style: {
                        left: "24%",
                        top: "20%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-1_4_Erschoepfung/Kacheln/kachel-ERSCHOEPFUNG_VITAAKTIV.png")})`
                    }
                },
                {
                    action: 'product',
                    actionParam: 'erschoepfung_pro_balance',
                    style: {
                        left: "42%",
                        top: "20%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-1_4_Erschoepfung/Kacheln/kachel-ERSCHOEPFUNG_PROBALANCE.png")})`
                    }
                },


                //ZEILE 2
                {
                    action: 'product',
                    actionParam: 'erschoepfung_mind_master_extreme',
                    style: {
                        left: "6%",
                        top: "39%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-1_4_Erschoepfung/Kacheln/kachel-ERSCHOEPFUNG_MINDMASEREXTREME.png")})`
                    }
                },
                {
                    action: 'product',
                    actionParam: 'erschoepfung_mind_master_red',
                    style: {
                        left: "24%",
                        top: "39%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-1_4_Erschoepfung/Kacheln/kachel-ERSCHOEPFUNG_MINDMASERRED.png")})`
                    }
                },
                {
                    action: 'product',
                    actionParam: 'erschoepfung_mind_master_green',
                    style: {
                        left: "42%",
                        top: "39%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-1_4_Erschoepfung/Kacheln/kachel-ERSCHOEPFUNG_MINDMASERGREEN.png")})`
                    }
                },


                //ZEILE 3
                {
                    action: 'product',
                    actionParam: 'erschoepfung_reishi',
                    style: {
                        left: "6%",
                        top: "58%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-1_4_Erschoepfung/Kacheln/kachel-ERSCHOEPFUNG_REISHI.png")})`
                    }
                },
            ]
        },



        stress: {
            backgroundImage: `url(${require('@/assets/Ebene-2/zeile-1_5_Stress/LR-anwendungsgebiete_STRESS-hauptseite-hintergrund.jpg')})`,
            backDestinationName: 'root',
            backDestinationParam: '',
            tiles: [
                //ZEILE 1
                {
                    action: 'slides',
                    actionParam: 'stress_mind_master_green_und_red',
                    style: {
                        left: "6%",
                        top: "20%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-1_5_Stress/Kacheln/kachel-STRESS_MINDMASTERGREENRED.png")})`
                    }
                },
                {
                    action: 'product',
                    actionParam: 'stress_mind_master_extreme',
                    style: {
                        left: "24%",
                        top: "20%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-1_5_Stress/Kacheln/kachel-STRESS_MINDMASTEREXTREME.png")})`
                    }
                },
                {
                    action: 'product',
                    actionParam: 'stress_pro12',
                    style: {
                        left: "42%",
                        top: "20%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-1_5_Stress/Kacheln/kachel-STRESS_PRO12.png")})`
                    }
                },


                //ZEILE 2
                {
                    action: 'product',
                    actionParam: 'stress_pro_balance',
                    style: {
                        left: "6%",
                        top: "39%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-1_5_Stress/Kacheln/kachel-STRESS_PROBALANCE.png")})`
                    }
                },
                {
                    action: 'product',
                    actionParam: 'stress_colostrum_kapseln',
                    style: {
                        left: "24%",
                        top: "39%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-1_5_Stress/Kacheln/kachel-STRESS_COLOSTRUMKAPSELN.png")})`
                    }
                },
                {
                    action: 'product',
                    actionParam: 'stress_colostrum_liquid',
                    style: {
                        left: "42%",
                        top: "39%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-1_5_Stress/Kacheln/kachel-STRESS_COLOSTRUMLIQUID.png")})`
                    }
                },


                //ZEILE 3
                {
                    action: 'product',
                    actionParam: 'stress_reishi',
                    style: {
                        left: "6%",
                        top: "58%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-1_5_Stress/Kacheln/kachel-STRESS_REISHI.png")})`
                    }
                },
            ]
        },


        allergien: {
            backgroundImage: `url(${require('@/assets/Ebene-2/zeile-2_1_Allergien/LR-anwendungsgebiete_ALLERGIEN_hauptseite-hintergrund.jpg')})`,
            backDestinationName: 'root',
            backDestinationParam: '',
            tiles: [
                //ZEILE 1
                {
                    action: 'slides',
                    actionParam: 'allergien_trinkgele',
                    style: {
                        left: "6%",
                        top: "20%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-2_1_Allergien/Kacheln/kachel-ALLERGIEN_TRINKGELE.png")})`
                    }
                },
                {
                    action: 'product',
                    actionParam: 'allergien_cistus_incanus_tee',
                    style: {
                        left: "24%",
                        top: "20%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-2_1_Allergien/Kacheln/kachel-ALLERGIEN_CISTUSTEE.png")})`
                    }
                },
                {
                    action: 'product',
                    actionParam: 'allergien_cistus_incanus_kapsel',
                    style: {
                        left: "42%",
                        top: "20%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-2_1_Allergien/Kacheln/kachel-ALLERGIEN_CISTUSKAPSELN.png")})`
                    }
                },


                //ZEILE 2
                {
                    action: 'product',
                    actionParam: 'allergien_microsilver_face',
                    style: {
                        left: "6%",
                        top: "39%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-2_1_Allergien/Kacheln/kachel-ALLERGIEN_MICROSILVERFACE.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'allergien_trockene_haut',
                    style: {
                        left: "24%",
                        top: "39%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-2_1_Allergien/Kacheln/kachel-ALLERGIEN_PFLEGEBEITROCKENERHAUT.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'allergien_spezial_sonnenpflege',
                    style: {
                        left: "42%",
                        top: "39%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-2_1_Allergien/Kacheln/kachel-ALLERGIEN_SONNENPFLEGE.png")})`
                    }
                },


                //ZEILE 3
                {
                    action: 'product',
                    actionParam: 'allergien_pro12',
                    style: {
                        left: "6%",
                        top: "58%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-2_1_Allergien/Kacheln/kachel-ALLERGIEN_PRO12.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'allergien_hautpflege_allgemein',
                    style: {
                        left: "24%",
                        top: "58%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-2_1_Allergien/Kacheln/kachel-ALLERGIEN_LRHAUTPFLEGEPRODUKTEALLGEMEIN.png")})`
                    }
                },
            ]
        },


        verletzungen: {
            backgroundImage: `url(${require('@/assets/Ebene-2/zeile-2_2_Verletzungen/LR-anwendungsgebiete_VERLETZUNGEN_hauptseite-hintergrund.jpg')})`,
            backDestinationName: 'root',
            backDestinationParam: '',
            tiles: [
                //ZEILE 1
                {
                    action: 'product',
                    actionParam: 'verletzungen_specialcare_box',
                    style: {
                        left: "6%",
                        top: "20%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-2_2_Verletzungen/Kacheln/kachel-VERLETZUNGEN_specialcarebox.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'verletzungen_notfallspray',
                    style: {
                        left: "24%",
                        top: "20%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-2_2_Verletzungen/Kacheln/kachel-VERLETZUNGEN_notfallspray.png")})`
                    }
                },

                //ZEILE 2
                {
                    action: 'slides',
                    actionParam: 'verletzungen_concentrat',
                    style: {
                        left: "6%",
                        top: "39%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-2_2_Verletzungen/Kacheln/kachel-VERLETZUNGEN_conzentrat.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'verletzungen_propolis_creme',
                    style: {
                        left: "24%",
                        top: "39%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-2_2_Verletzungen/Kacheln/kachel-VERLETZUNGEN_propolis.png")})`
                    }
                },

            ]
        },


        // zahnmund: {
        //     backgroundImage: `url(${require('@/assets/Ebene-2/zeile-2_3_ZahnMund/LR-anwendungsgebiete_ZAHNMUND-hauptseite-hintergrund.jpg')})`,
        //     backDestinationName: 'root',
        //     backDestinationParam: '',
        //     tiles: [
        //         //ZEILE 1
        //         {
        //             action: 'product',
        //             actionParam: 'zahnmund_zahngel_ohne_fluorid',
        //             style: {
        //                 left: "6%",
        //                 top: "20%",
        //                 backgroundImage: `url(${require("@/assets/Ebene-2/zeile-2_3_ZahnMund/Kacheln/kachel-ZAHNMUND_ALOEVERAZAHNGEL.png")})`
        //             }
        //         },
        //         {
        //             action: 'product',
        //             actionParam: 'zahnmund_zahngel_mit_fluorid',
        //             style: {
        //                 left: "24%",
        //                 top: "20%",
        //                 backgroundImage: `url(${require("@/assets/Ebene-2/zeile-2_3_ZahnMund/Kacheln/kachel-ZAHNMUND_ALOEVERAZAHNCREME.png")})`
        //             }
        //         },
        //         {
        //             action: 'product',
        //             actionParam: 'zahnmund_zahngel_mit_fluorid',
        //             style: {
        //                 left: "42%",
        //                 top: "20%",
        //                 backgroundImage: `url(${require("@/assets/Ebene-2/zeile-2_3_ZahnMund/Kacheln/kachel-ZAHNMUND_ALOEVERAZAHNCREME.png")})`
        //             }
        //         },

        //         //ZEILE 2
        //         {
        //             action: 'product',
        //             actionParam: 'zahnmund_microsilver_zahncreme',
        //             style: {
        //                 left: "6%",
        //                 top: "39%",
        //                 backgroundImage: `url(${require("@/assets/Ebene-2/zeile-2_3_ZahnMund/Kacheln/kachel-ZAHNMUND_MICROSILVERZAHNCREME.png")})`
        //             }
        //         },
        //         {
        //             action: 'product',
        //             actionParam: 'zahnmund_cistus_incanus_spray',
        //             style: {
        //                 left: "24%",
        //                 top: "39%",
        //                 backgroundImage: `url(${require("@/assets/Ebene-2/zeile-2_3_ZahnMund/Kacheln/kachel-ZAHNMUND_CISTURSPRAY.png")})`
        //             }
        //         },
        //         {
        //             action: 'product',
        //             actionParam: 'zahnmund_cistus_incanus_spray',
        //             style: {
        //                 left: "42%",
        //                 top: "39%",
        //                 backgroundImage: `url(${require("@/assets/Ebene-2/zeile-2_3_ZahnMund/Kacheln/kachel-ZAHNMUND_CISTURSPRAY.png")})`
        //             }
        //         },

        //         //ZEILE 3
        //         {
        //             action: 'product',
        //             actionParam: 'zahnmund_microsilver_kaugummi',
        //             style: {
        //                 left: "6%",
        //                 top: "58%",
        //                 backgroundImage: `url(${require("@/assets/Ebene-2/zeile-2_3_ZahnMund/Kacheln/kachel-ZAHNMUND_MICROSILVERKAUGUMMI.png")})`
        //             }
        //         },

        //     ]
        // },

        zahnmund: {
            backgroundImage: `url(${require('@/assets/Ebene-2/zeile-2_3_ZahnMund/LR-anwendungsgebiete_ZAHNMUND-hauptseite-hintergrund.jpg')})`,
            backDestinationName: 'root',
            backDestinationParam: '',
            tiles: [
                //ZEILE 1
                {
                    action: 'product',
                    actionParam: 'zahnmund_zahngel_ohne_fluorid',
                    style: {
                        left: "6%",
                        top: "20%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-2_3_ZahnMund/Kacheln/kachel-ZAHNMUND_ALOEVERAZAHNGEL.png")})`
                    }
                },
                {
                    action: 'product',
                    actionParam: 'zahnmund_zahngel_mit_fluorid',
                    style: {
                        left: "24%",
                        top: "20%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-2_3_ZahnMund/Kacheln/kachel-ZAHNMUND_ALOEVERAZAHNCREME.png")})`
                    }
                },
                {
                    action: 'product',
                    actionParam: 'zahnmund_cistus_incanus_spray',
                    style: {
                        left: "42%",
                        top: "20%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-2_3_ZahnMund/Kacheln/kachel-ZAHNMUND_CISTURSPRAY.png")})`
                    }
                },

                //ZEILE 2
                {
                    action: 'product',
                    actionParam: 'zahnmund_microsilver_zahncreme',
                    style: {
                        left: "6%",
                        top: "39%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-2_3_ZahnMund/Kacheln/kachel-ZAHNMUND_MICROSILVERZAHNCREME.png")})`
                    }
                },
                {
                    action: 'product',
                    actionParam: 'zahnmund_microsilver_mundspuelung',
                    style: {
                        left: "24%",
                        top: "39%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-2_3_ZahnMund/Kacheln/ZAHNMUND_kachel_mundspuelung.png")})`
                    }
                },
                {
                    action: 'product',
                    actionParam: 'zahnmund_microsilver_mundspray',
                    style: {
                        left: "42%",
                        top: "39%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-2_3_ZahnMund/Kacheln/ZAHNMUND_kachel_mundspray.png")})`
                    }
                },

                //ZEILE 3
                {
                    action: 'product',
                    actionParam: 'zahnmund_microsilver_kaugummi',
                    style: {
                        left: "6%",
                        top: "58%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-2_3_ZahnMund/Kacheln/kachel-ZAHNMUND_MICROSILVERKAUGUMMI.png")})`
                    }
                },

            ]
        },










        fuerjedelebenslage: {
            backgroundImage: `url(${require('@/assets/Ebene-2/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/LR-LIFETAKT_loesungen-fuer-jede-lebenslage_HAUPTSEITE.jpg')})`,
            backDestinationName: 'root',
            backDestinationParam: '',
            tiles: [
                //ZEILE 1
                {
                    action: 'slides',
                    actionParam: 'fuerjedelebenslage_daily_essentials',
                    style: {
                        left: "6%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Kacheln/loesungen-fuer-jede-lebenslage_kachl_DAILYESSENTIALS.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'fuerjedelebenslage_mental_power',
                    style: {
                        left: "24%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Kacheln/loesungen-fuer-jede-lebenslage_kachl_MENTALPOWER.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'fuerjedelebenslage_seasonal_support',
                    style: {
                        left: "42%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Kacheln/loesungen-fuer-jede-lebenslage_kachl_SEASONALSUPPORT.png")})`
                    }
                },

                //ZEILE 2
                {
                    action: 'slides',
                    actionParam: 'fuerjedelebenslage_pro_activity',
                    style: {
                        left: "6%",
                        top: "43%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Kacheln/loesungen-fuer-jede-lebenslage_kachl_PROACTIVITY.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'fuerjedelebenslage_vital_care',
                    style: {
                        left: "24%",
                        top: "43%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Kacheln/loesungen-fuer-jede-lebenslage_kachl_VITALCARE.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'fuerjedelebenslage_body_mission',
                    style: {
                        left: "42%",
                        top: "43%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Kacheln/loesungen-fuer-jede-lebenslage_kachl_BODYMISSION.png")})`
                    }
                },


                //ZEILE 3
                {
                    action: 'slides',
                    actionParam: 'fuerjedelebenslage_true_beauty',
                    style: {
                        left: "6%",
                        top: "61%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Kacheln/loesungen-fuer-jede-lebenslage_kachl_TRUEBEAUTY.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'fuerjedelebenslage_night_essentials',
                    style: {
                        left: "24%",
                        top: "61%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Kacheln/loesungen-fuer-jede-lebenslage_kachl_NIGHTESSENTIALS.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'fuerjedelebenslage_5in1_mensshot',
                    style: {
                        left: "42%",
                        top: "61%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Kacheln/LR-LIFETAKT_loesungen-fuer-jede-lebenslage_kachel-5in1mensho.png")})`
                    }
                },

                //ZEILE 4
                {
                    action: 'slides',
                    actionParam: 'fuerjedelebenslage_cannaloe',
                    style: {
                        left: "6%",
                        top: "79%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Kacheln/LR-LIFETAKT_loesungen-fuer-jede-lebenslage_kachel-cannaloe.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'fuerjedelebenslage_cell_essence',
                    style: {
                        left: "24%",
                        top: "79%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Kacheln/LR-LIFETAKT_kachel-cell-essence.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'fuerjedelebenslage_lr_lifetakt_konzept',
                    style: {
                        left: "42%",
                        top: "79%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_1_LR-LIFETAKT_produkte fuer jede lebenslage/Kacheln/loesungen-fuer-jede-lebenslage_kachl_LRLIFETAKTKONZEPT.png")})`
                    }
                },
            ]
        },





        einzelneprodukte: {
            backgroundImage: `url(${require('@/assets/Ebene-2/zeile-3_2_LR-LIFETAKT_einzelne-produkte/LR-LIFETAKT_einzelne-produkte_1-HINTERGRUND.jpg')})`,
            backDestinationName: 'root',
            backDestinationParam: '',

            tiles: [
                //ZEILE 1
                {
                    action: 'slides',
                    actionParam: 'einzelneprodukte_aloe_vera_drinking_gel',
                    style: {
                        left: "6%",
                        top: "20%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Kacheln/kachel-einzelneprodukte_ALOEVERADRINKINGGEL.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'einzelneprodukte_mind_master',
                    style: {
                        left: "24%",
                        top: "20%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Kacheln/kachel-einzelneprodukte_MINDMASTER.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'einzelneprodukte_cistus_incanus',
                    style: {
                        left: "42%",
                        top: "20%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Kacheln/kachel-einzelneprodukte_CISTUSINCANUS.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'einzelneprodukte_colostrum',
                    style: {
                        left: "60%",
                        top: "20%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Kacheln/kachel-einzelneprodukte_COLOSTRUM.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'einzelneprodukte_pro12',
                    style: {
                        left: "78%",
                        top: "20%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Kacheln/kachel-einzelneprodukte_PRO12.png")})`
                    }
                },


                //ZEILE 2
                {
                    action: 'slides',
                    actionParam: 'einzelneprodukte_vita_activ',
                    style: {
                        left: "6%",
                        top: "39%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Kacheln/kachel-einzelneprodukte_VITAAKTIV.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'einzelneprodukte_reishi_plus',
                    style: {
                        left: "24%",
                        top: "39%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Kacheln/kachel-einzelneprodukte_REISHIPLUS.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'einzelneprodukte_active_freedom_kapseln',
                    style: {
                        left: "42%",
                        top: "39%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Kacheln/kachel-einzelneprodukte_AKTIVFREEEDOM.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'einzelneprodukte_super_omega',
                    style: {
                        left: "60%",
                        top: "39%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Kacheln/kachel-einzelneprodukte_SUPEROMEGA.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'einzelneprodukte_woman_phyto',
                    style: {
                        left: "78%",
                        top: "39%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Kacheln/kachel-einzelneprodukte_WOMANPHYTO.png")})`
                    }
                },


                //ZEILE 3
                {
                    action: 'slides',
                    actionParam: 'einzelneprodukte_fiber_boost',
                    style: {
                        left: "6%",
                        top: "58%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Kacheln/kachel-einzelneprodukte_FIBERBOOST.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'einzelneprodukte_herbal_fasting_tea',
                    style: {
                        left: "24%",
                        top: "58%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Kacheln/kachel-einzelneprodukte_HERBALFASTINGTEA.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'einzelneprodukte_protein_power',
                    style: {
                        left: "42%",
                        top: "58%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Kacheln/kachel-einzelneprodukte_PRPOTEINPOWER.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'einzelneprodukte_pro_balance',
                    style: {
                        left: "60%",
                        top: "58%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Kacheln/kachel-einzelneprodukte_PROBALANCE.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'einzelneprodukte_figu_active',
                    style: {
                        left: "78%",
                        top: "58%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Kacheln/kachel-einzelneprodukte_FIGUACTIVE.png")})`
                    }
                },


                //ZEILE 4
                {
                    action: 'slides',
                    actionParam: 'einzelneprodukte_die_aloe_vera',
                    style: {
                        left: "6%",
                        top: "77%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Kacheln/kachel-einzelneprodukte_DIEALOEVERA.png")})`
                    }
                },
                {
                    action: '',
                    actionParam: '',
                    style: {
                        left: "24%",
                        top: "77%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Kacheln/kachel-einzelneprodukte_NEUTRAL.png")})`
                    }
                },
                {
                    action: '',
                    actionParam: '',
                    style: {
                        left: "42%",
                        top: "77%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Kacheln/kachel-einzelneprodukte_NEUTRAL.png")})`
                    }
                },
                {
                    action: '',
                    actionParam: '',
                    style: {
                        left: "60%",
                        top: "77%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Kacheln/kachel-einzelneprodukte_NEUTRAL.png")})`
                    }
                },
                {
                    action: '',
                    actionParam: '',
                    style: {
                        left: "78%",
                        top: "77%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_2_LR-LIFETAKT_einzelne-produkte/Kacheln/kachel-einzelneprodukte_NEUTRAL.png")})`
                    }
                },
            ]
        },



        kopfbisfuss: {
            backgroundImage: `url(${require('@/assets/Ebene-2/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/haut-und-haarpflege_hauptseite_HINTERGRUND.jpg')})`,
            backDestinationName: 'root',
            backDestinationParam: '',
            tiles: [
                //ZEILE 1
                {
                    action: 'menu',
                    actionParam: 'kopfbisfuss_lr_aloe_via',
                    style: {
                        left: "7.5%",
                        top: "20%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/haut-und-haarpflege_kachel_ALOEVIA.png")})`
                    }
                },
                {
                    action: 'menu',
                    actionParam: 'kopfbisfuss_lr_zeitgard',
                    style: {
                        left: "28%",
                        top: "20%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/haut-und-haarpflege_kachel_ZEITGARD.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'kopfbisfuss_lr_microsilver_plus',
                    style: {
                        left: "49.5%",
                        top: "20%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/haut-und-haarpflege_kachel_MICROSILVER.png")})`
                    }
                },
            ]
        },




        duefte: {
            backgroundImage: `url(${require('@/assets/Ebene-2/zeile-3_5_Damen_und_Herrenduefte/damen_und_herren_duefte1_HINTERGRUND.jpg')})`,
            backDestinationName: 'root',
            backDestinationParam: '',

            tiles: [
                //ZEILE 1
                {
                    action: 'slides',
                    actionParam: 'duefte_starbox',
                    style: {
                        left: "6%",
                        top: "20%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_5_Damen_und_Herrenduefte/Kacheln/damen_und_herren_duefte_kachel_STARBOX.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'duefte_herren_stars',
                    style: {
                        left: "24%",
                        top: "20%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_5_Damen_und_Herrenduefte/Kacheln/damen_und_herren_duefte_kachel_HERRENSTARS.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'duefte_herren_individuals',
                    style: {
                        left: "42%",
                        top: "20%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_5_Damen_und_Herrenduefte/Kacheln/damen_und_herren_duefte_kachel_HERRENINDIVIDUALS.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'duefte_herren_classics',
                    style: {
                        left: "60%",
                        top: "20%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_5_Damen_und_Herrenduefte/Kacheln/damen_und_herren_duefte_kachel_HERRENCLASSICS.png")})`
                    }
                },


                //ZEILE 2
                {
                    action: 'slides',
                    actionParam: 'duefte_damen_stars',
                    style: {
                        left: "6%",
                        top: "39%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_5_Damen_und_Herrenduefte/Kacheln/damen_und_herren_duefte_kachel_DAMENSTARS.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'duefte_damen_essenzen',
                    style: {
                        left: "24%",
                        top: "39%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_5_Damen_und_Herrenduefte/Kacheln/damen_und_herren_duefte_kachel_DAMENESSENZEN.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'duefte_damen_individuals',
                    style: {
                        left: "42%",
                        top: "39%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_5_Damen_und_Herrenduefte/Kacheln/damen_und_herren_duefte_kachel_DAMENINDIVIDUALS.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'duefte_damen_classics',
                    style: {
                        left: "60%",
                        top: "39%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_5_Damen_und_Herrenduefte/Kacheln/damen_und_herren_duefte_kachel_DAMENCLASSICS.png")})`
                    }
                },
            ]
        },



        kopfbisfuss_lr_aloe_via: {
            backgroundImage: `url(${require('@/assets/Ebene-2/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/haut-und-haarpflege_LR_ALOE_VIA1_hintergrund.jpg')})`,
            backDestinationName: 'tilepage',
            backDestinationParam: 'kopfbisfuss',
            tiles: [
                //ZEILE 1
                {
                    action: 'slides',
                    actionParam: 'kopfbisfuss_lr_aloe_via_die_aloe_vera',
                    style: {
                        left: "6%",
                        top: "20%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Kacheln/kachel_aloevia_DIEALOEVERA.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'kopfbisfuss_lr_aloe_via_special_care',
                    style: {
                        left: "24%",
                        top: "20%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Kacheln/kachel_aloevia_SPECIALCARE.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'kopfbisfuss_lr_aloe_via_oral_care',
                    style: {
                        left: "42%",
                        top: "20%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Kacheln/kachel_aloevia_ORALCARE.png")})`
                    }
                },


                //ZEILE 2
                {
                    action: 'slides',
                    actionParam: 'kopfbisfuss_lr_aloe_via_hair_care',
                    style: {
                        left: "6%",
                        top: "39%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Kacheln/kachel_aloevia_HAIRCARE.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'kopfbisfuss_lr_aloe_via_face_care',
                    style: {
                        left: "24%",
                        top: "39%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Kacheln/kachel_aloevia_FACECARE.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'kopfbisfuss_lr_aloe_via_body_care',
                    style: {
                        left: "42%",
                        top: "39%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Kacheln/kachel_aloevia_BODYCARE.png")})`
                    }
                },

                //ZEILE 3
                {
                    action: 'slides',
                    actionParam: 'kopfbisfuss_lr_aloe_via_baby_kids_care',
                    style: {
                        left: "6%",
                        top: "58%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Kacheln/kachel_aloevia_BABYKIDSCARE.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'kopfbisfuss_lr_aloe_via_men_care',
                    style: {
                        left: "24%",
                        top: "58%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Kacheln/kachel_aloevia_MENCARE.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'kopfbisfuss_lr_aloe_via_sun_care',
                    style: {
                        left: "42%",
                        top: "58%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ALOE VIA/Kacheln/kachel_aloevia_SUNCARE.png")})`
                    }
                },

            ]
        },

        kopfbisfuss_lr_zeitgard: {
            backgroundImage: `url(${require('@/assets/Ebene-2/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/haut-und-haarpflege_ZEITGUARD1-hintergurnd.jpg')})`,
            backDestinationName: 'tilepage',
            backDestinationParam: 'kopfbisfuss',
            infoImage: 'kopfbisfuss_lr_zeitgard_images',
            tiles: [
                //ZEILE 1
                {
                    action: 'slides',
                    actionParam: 'kopfbisfuss_lr_zeitgard_cleansing',
                    style: {
                        left: "6.8%",
                        top: "33%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/Kacheln/kachel-zeitgard_ZEITGARD1.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'kopfbisfuss_lr_zeitgard_anti_age',
                    style: {
                        left: "24.6%",
                        top: "33%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/Kacheln/kachel-zeitgard_ZEITGARD2.png")})`
                    }
                },
                {
                    action: 'slides',
                    actionParam: 'kopfbisfuss_lr_zeitgard_care',
                    style: {
                        left: "42.4%",
                        top: "33%",
                        backgroundImage: `url(${require("@/assets/Ebene-2/zeile-3_3_LR-Gesunde_Pflege_von_Kopf_bis_Fuss/ZEITGARD/Kacheln/kachel-zeitgard_ZEITGARD-CARESYSTEM.png")})`
                    }
                },
            ]
        },

    }
}